import type { ReactNode } from 'react'
import styles from './SectionTitle.module.css'

export function SectionTitle({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className={styles.wrap}>
      <h2 className={styles.title}>{children}</h2>
      {action}
    </div>
  )
}
